<div [style.--condition-columns]="columns()" [ngClass]="{ fh: settingsManager.settings.fhStyle }">
  <div class="condition-container">
    @for (condition of conditions | trackUUID; track condition._trackUUID; let i = $index) {
      @if (isValueCondition(condition)) {
        <div class="value-condition">
          <ghs-pointer-input
            class="button"
            [ngClass]="{
              disabled: isDisabled(condition) || (!condition.types.includes(ConditionType.stack) && getValue(condition) <= 1)
            }"
            tabclick
            (singleClick)="dec(condition)"
            [repeat]="true"
          >
            <img class="ghs-svg" src="./assets/images/minus.svg" />
          </ghs-pointer-input>
          <ng-container *ngTemplateOutlet="conditionItem; context: { $implicit: condition }"></ng-container>
          <ghs-pointer-input
            class="button"
            [ngClass]="{ disabled: isDisabled(condition) }"
            tabclick
            (singleClick)="inc(condition)"
            [repeat]="true"
          >
            <img class="ghs-svg" src="./assets/images/plus.svg" />
          </ghs-pointer-input>
        </div>
      } @else {
        <ng-container *ngTemplateOutlet="conditionItem; context: { $implicit: condition }"></ng-container>
      }
      @if (conditionSeparator.includes(i)) {
        <div class="separator"></div>
      }
    }

    <ng-template #conditionItem let-condition>
      <a class="item" [ngClass]="{ disabled: isDisabled(condition) }">
        <span
          class="condition"
          tabclick
          (click)="toggleCondition(condition)"
          [ghs-tooltip]="'game.condition.' + condition.name + '.hint'"
          [originX]="'center'"
          [overlayX]="'center'"
          [originY]="'top'"
          [overlayY]="'bottom'"
          [ngClass]="{
            active: (!immunityEnabled && hasCondition(condition)) || (immunityEnabled && immunities.includes(condition.name)),
            immunity: isImmune(condition.name)
          }"
        >
          <img [src]="'./assets/images' + (settingsManager.settings.fhStyle ? '/fh' : '') + '/condition/' + condition.name + '.svg'" />
          @if (condition.types.includes(ConditionType.stack)) {
            <span [ngClass]="{ stack: true }" class="value">{{ getValue(condition) | ghsValueSign }}</span>
          }
          @if (condition.types.includes(ConditionType.upgrade)) {
            <span class="value">{{ getValue(condition) }}</span>
          }
        </span>
        @if (!isTrapEntity && isPermanent(condition.name)) {
          <span class="condition permanent permanent-overlay"></span>
        }
        @if (!isTrapEntity && isRoundExpire(condition.name)) {
          <span class="condition round round-overlay"></span>
        }
        @if (!isTrapEntity && isExpire(condition.name)) {
          <span class="condition expire expire-overlay"></span>
        }
      </a>
    </ng-template>

    @if (conditions.length && !isTrapEntity) {
      <div class="separator"></div>
      <a class="item">
        <span
          class="condition toggle"
          [ngClass]="{ active: permanentEnabled }"
          tabclick
          (click)="togglePermanentEnabled()"
          [ghs-tooltip]="'game.condition.permanent.hint'"
          [originX]="'center'"
          [overlayX]="'center'"
          [originY]="'top'"
          [overlayY]="'bottom'"
        >
          <img src="./assets/images/condition/permanent.svg" />
        </span>
      </a>
      <a class="item">
        <span
          class="condition toggle"
          [ngClass]="{ active: roundExpireEnabled }"
          tabclick
          (click)="toggleRoundExpireEnabled()"
          [ghs-tooltip]="'game.condition.roundExpire.hint'"
          [originX]="'center'"
          [overlayX]="'center'"
          [originY]="'top'"
          [overlayY]="'bottom'"
        >
          <img src="./assets/images/condition/round.svg" />
        </span>
      </a>
      <!--
    <a class="item">
      <span class="condition toggle" [ngClass]="{'active': expireEnabled}" tabclick (click)="toggleExpireEnabled()"
        [ghs-tooltip]="'game.condition.expire.hint'" [originX]="'center'" [overlayX]="'center'" [originY]="'top'"
        [overlayY]="'bottom'">
        <img src="./assets/images/condition/expire.svg" />
      </span>
    </a>
    -->
      <a class="item">
        <span
          class="condition toggle"
          [ngClass]="{ active: immunityEnabled }"
          tabclick
          (click)="toggleImmunityEnabled()"
          [ghs-tooltip]="'game.condition.immune.hint'"
          [originX]="'center'"
          [overlayX]="'center'"
          [originY]="'top'"
          [overlayY]="'bottom'"
        >
          <img [src]="'./assets/images' + (settingsManager.settings.fhStyle ? '/fh/condition/immune.svg' : '/condition/immunity.svg')"
        /></span>
      </a>
    }
  </div>
</div>
